module.exports = __webpack_public_path__ + "img/youtube.94eb8307.svg";